export class Versions {
    constructor() {}

    public assortmentExcel: string = '1.2.3';
    public changeBufferExcel: string = '1.2.3';
    public bufferTableExcel: string = '1.1.1';
    public marketingPurchase: string = '1.1.1';
    public orders: string = '1.1.0';
    public stocks: string = '1.1.6';
    public itemProperties: string = '1.0.0';
}



// WEBPACK FOOTER //
// ./src/app/shared/models/vesions.ts